import React, { useEffect, useState } from 'react';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';

const TimePickersV2 = ({ onChange, dayKey, start, stop }) => {
  const [startValue, setStartValue] = useState(start);
  const [stopValue, setStopValue] = useState(stop);

  useEffect(() => {
    if (startValue && stopValue) {
      onChange(startValue, stopValue, dayKey);
    }
  }, [startValue, stopValue]);

  useEffect(() => {
    setStartValue(start);
    setStopValue(stop);
  }, [start, stop]);

  return (
    <div className='builder-flex builder-items-center'>
      <TimePicker showSecond={false} onChange={(value) => value && setStartValue(value.format('HH:mm'))} value={startValue ? moment(startValue, 'HH:mm') : undefined} placeholder='--:--' minuteStep={5} addon={(param) => {}} />
      <span className='builder-mx-2 builder-text-gray-300 builder-text-sm'>–</span>
      <TimePicker showSecond={false} onChange={(value) => value && setStopValue(value.format('HH:mm'))} value={stopValue ? moment(stopValue, 'HH:mm') : undefined} placeholder='--:--' minuteStep={5} />
    </div>
  );
};

export default TimePickersV2;
